"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.signOut = void 0;
const react_1 = require("next-auth/react");
const get_cached_session_store_1 = require("./utils/get-cached-session-store");
/**
 * Call next-auth signOut and clear the cached session.
 *
 * Signs the user out, by removing the session cookie.
 * Automatically adds the CSRF token to the request.
 *
 * [Documentation](https://next-auth.js.org/getting-started/client#signout)
 * @param {...any} args
 */
const signOut = (...args) => {
    (0, get_cached_session_store_1.clearCachedSession)();
    return (0, react_1.signOut)(...args);
};
exports.signOut = signOut;
